import { render, staticRenderFns } from "./CreateEditModeloPecaModal.vue?vue&type=template&id=d2a85078&"
import script from "./CreateEditModeloPecaModal.vue?vue&type=script&lang=js&"
export * from "./CreateEditModeloPecaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports